import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import ESignGrid from '../components/esign/esign-grid'

const tableHeader = ['Access Code', 'Transaction ID', 'Status', 'Created']

export const ESign = (props) => {
  const { isFetching } = props
  return <ESignGrid isLoading={isFetching} pageTitle={'e-Sign'} tableHeader={tableHeader} />
}

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ESign))
